import { AlertTriangle } from "lucide-react";

/**
 * Inline warning shown below a child table row when a server fetch fails.
 * Styled as a non-blocking amber warning — the user can still fill fields manually.
 */
export function ServerFetchError() {
  return (
    <div className="col-span-full flex items-center gap-1.5 px-4 py-1.5 text-amber-600 text-xs">
      <AlertTriangle className="h-3.5 w-3.5 flex-shrink-0" />
      <span>
        Could not load item details — fill manually or re-select the item
      </span>
    </div>
  );
}
